import axios from "axios";
import { WalletSummaryResponse } from "redmond";

import { config } from "../../config";
import { travelWalletApiPrefix } from "../../paths";

const END_POINT: string = travelWalletApiPrefix;

export const fetchTravelWalletOffers = (): Promise<WalletSummaryResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(END_POINT, {
        baseURL: config.baseURL,
      });
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
